import NotesService from "external-services/notes-service/index";
import {scheduleActions} from 'app/reducers/schedule/slice';
import store from 'appRoot/Store';

const NS = 'NotesCtrl';

export default function NotesCtrl(
  $scope, $mdDialog, date
) {
  "ngInject";

  const vm = this;
  //-- define public properties
  vm.EDIT = 0;
  vm.LOADING = 1;
  vm.ERROR = 2;
  vm.state = vm.EDIT;
  //-- define public methods
  vm.close = close;
  vm.saveNotes = saveNotes;

  getNotes();

  function getNotes() {
    NotesService.getNote(date).then(function (noteDoc) {
      vm.noteDoc = noteDoc;
      vm.notes = noteDoc.note;
    }).catch(function () {
      vm.notes = '';
      vm.editNotes = true;
      vm.noteDoc = {};
    });
  }

  function saveNotes() {
    vm.state = vm.LOADING;
    if (!vm.noteDoc) {
      vm.noteDoc = {};
    }
    vm.noteDoc.note = vm.notes;
    NotesService.saveNote(date, vm.noteDoc).then(function () {
      store.dispatch(scheduleActions.setVenueNotes(vm.notes));
      close();
    }).catch(function () {
      vm.state = vm.ERROR;
    });
  }

  function close() {
    $mdDialog.hide();
  }
}
